import React, { useMemo } from "react"
import types from "prop-types"
import { Checkbox } from "components/shared/checkboxes"
import {
  SUBMITTER_COLUMN_TYPE, SURVEY_NON_ANONYMOUS_TYPE,
} from "reduxSlices/reportBuilderSlice"

const ColumnOption = ({
  option,
  selectedColumns,
  selectOption,
  deselectOption,
}) => {
  const isSelected = useMemo(() => (
    selectedColumns.some((col) => col.id === option.id && col.type === option.type)
  ), [option, selectedColumns])

  const toggleOption = isSelected
    ? () => deselectOption(option)
    : () => selectOption(option)

  const optionIdentifier = `columnOption-checkbox-${option.type}-${option.id}`

  const displayAsterisk = () => {
    const { type, label } = option
    if (type === SURVEY_NON_ANONYMOUS_TYPE) {
      return true
    }

    return (label.toLowerCase() === SUBMITTER_COLUMN_TYPE)
  }

  return (
    <div className="flex items-center">
      <Checkbox
        className="mr-4"
        onChange={toggleOption}
        uuid={optionIdentifier}
        value={isSelected}
      />
      <label className="cursor-pointer" htmlFor={optionIdentifier}>
        {option.label}{displayAsterisk() && " *"}
      </label>
    </div>
  )
}

ColumnOption.propTypes = {
  option: types.shape({
    id: types.oneOfType([types.string, types.number]).isRequired,
    label: types.string.isRequired,
    type: types.string.isRequired,
  }).isRequired,
  selectedColumns: types.arrayOf(
    types.shape({
      id: types.oneOfType([types.string, types.number]).isRequired,
      label: types.string.isRequired,
      type: types.string.isRequired,
    }),
  ).isRequired,
  selectOption: types.func.isRequired,
  deselectOption: types.func.isRequired,
}

export default React.memo(ColumnOption)
